<template lang="html">
  <div class="">
    Services View. (Future Feature)
  </div>
</template>

<script>
export default {}
</script>

<style lang="css" scoped>
.main {
  background: #f1cdb0;
}
</style>
